import { Card } from './card';

export const Cards: Card[] = [
  { id: 0, imageSrc: './assets/images/cards/Kartenset-0a.png' },
  { id: 1, imageSrc: './assets/images/cards/Kartenset-1a.png' },
  { id: 2, imageSrc: './assets/images/cards/Kartenset-2a.png' },
  { id: 3, imageSrc: './assets/images/cards/Kartenset-3a.png' },
  { id: 4, imageSrc: './assets/images/cards/Kartenset-4a.png' },
  { id: 5, imageSrc: './assets/images/cards/Kartenset-5a.png' },
  { id: 6, imageSrc: './assets/images/cards/Kartenset-6a.png' },
  { id: 7, imageSrc: './assets/images/cards/Kartenset-7a.png' },
  { id: 8, imageSrc: './assets/images/cards/Kartenset-8a.png' },
  { id: 9, imageSrc: './assets/images/cards/Kartenset-9a.png' },
  { id: 10, imageSrc: './assets/images/cards/Kartenset-10a.png' },
  { id: 11, imageSrc: './assets/images/cards/Kartenset-11a.png' },
  { id: 12, imageSrc: './assets/images/cards/Kartenset-12a.png' },
  { id: 13, imageSrc: './assets/images/cards/Kartenset-13a.png' },
  { id: 14, imageSrc: './assets/images/cards/Kartenset-14a.png' },
  { id: 15, imageSrc: './assets/images/cards/Kartenset-15a.png' },
  { id: 16, imageSrc: './assets/images/cards/Kartenset-16a.png' },
  { id: 17, imageSrc: './assets/images/cards/white.png'}
];
